import { TSubmitAssetData } from './types';

export const dehydrateFormData = (data: TSubmitAssetData): TSubmitAssetData => {
	const {
		assetName,
		assetType,
		imageUrl,
		createdAt,
		updatedAt,
		outputImageFormat,
		customResolutionWidth,
		customResolutionHeight,
		assetTag,
		customTag,
		isMultiple
	} = data;
	const hydratedData: TSubmitAssetData = {
		imageUrl,
		assetName,
		assetType,
		outputImageFormat,
		customResolutionWidth,
		customResolutionHeight,
		createdAt,
		updatedAt,
		assetTag,
		customTag,
		isMultiple
	};

	return hydratedData;
};

export const hydrateFormData = (data: TSubmitAssetData) => {
	const assetPostData: TSubmitAssetData = {
		assetName: data.assetName,
		assetType: data.assetType,
		outputImageFormat: data.outputImageFormat,
		customResolutionWidth: data.customResolutionWidth,
		customResolutionHeight: data.customResolutionHeight,
		createdAt: data.createdAt,
		updatedAt: data.updatedAt,
		imageUrl: data.imageUrl,
		assetTag: data.assetTag,
		customTag: data.customTag,
		isMultiple: data.isMultiple
	};
	return assetPostData;
};
